// Pure helpers for the Handicap Server summary widget. No React, no I/O.

const toHex = (color) => {
  if (/^#[0-9a-f]{6}$/i.test(color || '')) return color

  const rgb = /^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i.exec(color || '')
  if (!rgb) return null

  return '#' + [1, 2, 3].map(i => Number(rgb[i]).toString(16).padStart(2, '0')).join('')
}

const getLuminance = (hexColor) => {
  let r = parseInt(hexColor.substring(1, 3), 16) / 255
  let g = parseInt(hexColor.substring(3, 5), 16) / 255
  let b = parseInt(hexColor.substring(5, 7), 16) / 255

  r = r <= 0.03928 ? r / 12.92 : Math.pow((r + 0.055) / 1.055, 2.4)
  g = g <= 0.03928 ? g / 12.92 : Math.pow((g + 0.055) / 1.055, 2.4)
  b = b <= 0.03928 ? b / 12.92 : Math.pow((b + 0.055) / 1.055, 2.4)

  return 0.2126 * r + 0.7152 * g + 0.0722 * b
}

export const getFontColor = (color) => {
  const hex = toHex(color)
  if (!hex) return null

  return getLuminance(hex) > 0.5 ? '#000' : '#FFF'
}

// A real handicap display always contains a digit ("0.0", "5.1", "+2.9"); the
// backend's "no handicap" text (whatever its wording/locale) does not. Keying off
// "has a digit" avoids coupling the render to an exact backend display string.
export const hasHandicap = (view) => view != null && /\d/.test(view)

export const t = (key, opts) => !window.I18n ? '' : window.I18n.t(key, opts)

// Drill-down URL for one player. The base comes from Rails (REACT-045) and
// already carries page_id, so the separator depends on the query string.
export const playerSummaryUrl = (baseUrl, playerId) =>
  `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}player_id=${playerId}`
